import { render, staticRenderFns } from "./WatchTutorialDialogue.vue?vue&type=template&id=8033a252&lang=true&"
import script from "./WatchTutorialDialogue.vue?vue&type=script&lang=js&"
export * from "./WatchTutorialDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports